import { createContext, useContext } from 'react';

const ChatWebSocketServiceContext = createContext(null);

/**
 * Host-injected WebSocket facade compatible with ann-web-app `websocketService`:
 * `on(event, callback)`, `off(event, callback)`, and optionally `emit` for dev tooling.
 * Typically wired to the app WebSocket layer that dispatches `scope:CONVERSATION` events.
 */
export function ChatWebSocketServiceProvider({ service, children }) {
  return (
    <ChatWebSocketServiceContext.Provider value={service}>{children}</ChatWebSocketServiceContext.Provider>
  );
}

export function useChatWebSocketService() {
  return useContext(ChatWebSocketServiceContext);
}
